<template>
  <section class="ui-game-over" :class="{ 'ui-game-over--app' : $inApp }">
    <span class="ui-game-over__bg" />

    <div class="ui-game-over__banner">
      <img src="/img/misc/lettuce.png" alt="lettuce game over">
      <p>GAME OVER</p>
    </div>

    <div class="ui-game-over__content" :class="{ 'ui-game-over__content--app' : $inApp }">
      <CurrentScore class="ui-game-over__score" />

      <ButtonShare class="content__share" v-if="$inApp" />

      <TableScore
        class="content__table"
        theme="white"
        v-if="$inApp && $isLogged"
      />

      <ButtonRounded
        class="content__button"
        :content="$translate('start')"
        action="playAgain"
      />
    </div>

  </section>
</template>

<script>
import CurrentScore from '@/components/CurrentScore.vue';
import ButtonShare from '@/components/ButtonShare.vue';
import ButtonRounded from '@/components/ButtonRounded.vue';
import TableScore from '@/components/TableScore.vue';

export default {
  name: 'UIendGame',

  components: {
    CurrentScore,
    ButtonShare,
    ButtonRounded,
    TableScore,
  },

  mounted() {
    if (this.$inApp && this.$isLogged) {
      this.$store.dispatch('saveUserScore', this.$store.state.score);
    }
  },
};
</script>

<style lang="scss" scoped>
.ui-game-over {
  text-align: center;
  color: $color-white;

  &__bg {
    @include full();

    background-color: rgba($color-brown, 0.7);
  }

  &,
  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;
  }

  &__banner {
    position: absolute;
    top: 5.5vh;
    width: 22vw;
    min-width: 220px;
    left: 50%;

    img {
      display: block;
      position: relative;
      width: 100%;
    }

    p {
      position: absolute;
      bottom: 40%;
      left: 0;
      width: 100%;

      text-align: center;
      font-weight: bold;
      @extend %font-score;
    }
  }

  &__content {
    position: relative;
    height: 100%;
    padding-top: 24vh;

    @include mq($until: mobileL) {
      padding-top: 20vh;
    }

    .content__share,
    .content__table {
      position: relative;
      margin-top: 3vh;

      @include mq($until: mobileL) {
        margin-top: 5vh;
      }
    }

    .content__button {
      position: relative;
      margin-top: 8vh;

      @include mq($until: mobileL) {
        margin-top: 15vh;
      }
    }

    &.ui-game-over__content--app .content__button {
      margin-top: 5vh;
    }
  }

  &__cookie {
    position: absolute;
    bottom: 20px;
    width: 100%;
    color: $color-white;
  }
}
</style>
